export default __webpack_public_path__ + "static/humanMobile-803c436992ddd4009f62198fa7b81c72.svg";